import { takeEvery, takeLatest } from 'redux-saga/effects'

import {
  fetchTribe,
  deleteTribe,
  createTribe,
  fetchWaitlistQueued,
  fetchWaitlistTribeSelection,
  fetchWaitlistConverted,
  fetchWaitlistOthers,
  updateTribe,
  updateWaitlist,
  deleteWaitlist,
  fetchOpenbook,
  createOpenbook,
  fetchMoments
} from 'api'
import constants from 'app/constants'
import {
  fetchTribeData,
  fetchTribeDataSuccess,
  fetchWaitlistQueuedDataSuccess,
  fetchWaitlistQueuedData,
  fetchWaitlistTribeSelectionData,
  fetchWaitlistTribeSelectionDataSuccess,
  fetchWaitlistConvertedData,
  fetchWaitlistConvertedDataSuccess,
  fetchWaitlistOthersData,
  fetchWaitlistOthersDataSuccess,
  fetchOpenbookData,
  fetchOpenbookDataSuccess,
  updateCommunityDataSuccess,
  fetchClassroomMomentsData,
  fetchClassroomMomentsDataSuccess
} from 'app/store/actions/communityEntity'
import * as types from 'app/store/types/communityEntity'

import { handleFetch, handleUpdate } from './saga.helper'

// MEMBERSHIP / INACTIVE_TRIBE_MEMBERSHIP / REFERRAL_CODE / CLUB_REGISTRATION
// entity mappings were deleted 2026-05-16 — all of their api dependencies were
// _removed() stubs (no live backend), and no component in src/ dispatched the
// matching fetch action.
const mapping = {
  [constants.TRIBE]: {
    api: {
      fetch: fetchTribe,
      delete: deleteTribe,
      create: createTribe,
      update: updateTribe
    },
    action: {
      fetch: fetchTribeData,
      fetchSuccess: fetchTribeDataSuccess
    }
  },
  [constants.WAITLIST_QUEUED]: {
    api: {
      fetch: fetchWaitlistQueued,
      update: updateWaitlist,
      delete: deleteWaitlist
    },
    action: {
      fetch: fetchWaitlistQueuedData,
      fetchSuccess: fetchWaitlistQueuedDataSuccess
    }
  },
  [constants.WAITLIST_TRIBE_SELECTION]: {
    api: {
      fetch: fetchWaitlistTribeSelection
    },
    action: {
      fetch: fetchWaitlistTribeSelectionData,
      fetchSuccess: fetchWaitlistTribeSelectionDataSuccess
    }
  },
  [constants.WAITLIST_CONVERTED]: {
    api: {
      fetch: fetchWaitlistConverted
    },
    action: {
      fetch: fetchWaitlistConvertedData,
      fetchSuccess: fetchWaitlistConvertedDataSuccess
    }
  },
  [constants.WAITLIST_OTHERS]: {
    api: {
      fetch: fetchWaitlistOthers
    },
    action: {
      fetch: fetchWaitlistOthersData,
      fetchSuccess: fetchWaitlistOthersDataSuccess
    }
  },
  [constants.OPENBOOK]: {
    api: {
      fetch: fetchOpenbook,
      create: createOpenbook
    },
    action: {
      fetch: fetchOpenbookData,
      fetchSuccess: fetchOpenbookDataSuccess
    }
  },
  [constants.MOMENTS]: {
    api: {
      fetch: fetchMoments
    },
    action: {
      fetch: fetchClassroomMomentsData,
      fetchSuccess: fetchClassroomMomentsDataSuccess
    }
  }
}

export function* _fetchCommunityEntity({ queries, entity } = {}) {
  const mappingData = mapping[entity]
  yield handleFetch(mappingData, queries, entity)
}

export function* _updateCommunityEntity({ entity, event, value } = {}) {
  const mappingData = mapping[entity]
  yield handleUpdate(
    mappingData,
    entity,
    event,
    value,
    updateCommunityDataSuccess
  )
}

export function* watchFetchCommunityEntity() {
  yield takeLatest(
    [
      types.FETCH_TRIBE_DATA,
      types.FETCH_WAITLIST_QUEUED_DATA,
      types.FETCH_WAITLIST_TRIBE_SELECTION_DATA,
      types.FETCH_WAITLIST_CONVERTED_DATA,
      types.FETCH_WAITLIST_OTHERS_DATA,
      types.FETCH_OPENBOOK_DATA,
      types.FETCH_CLASSROOM_MOMENTS_DATA
    ],
    _fetchCommunityEntity
  )
}

export function* watchUpdateCommunityEntity() {
  yield takeEvery(types.UPDATE_COMMUNITY_DATA, _updateCommunityEntity)
}
